import React, { useEffect, useState } from "react";
import { Menu, Badge } from "antd";
import { DownloadOutlined } from "@ant-design/icons";
import axiosInstance from "../../../utils/axiosInstance";
import { RootState } from "../../../store/store";
import { useSelector } from "react-redux";
import { isEmptyObject } from "jquery";

interface IProps {
  handleClick: () => void;
  theme: string;
}

const ExportItem = (props: IProps) => {
  const [isHovered, setIsHovered] = useState(false);
  const [unnotifiedCount, setUnnotifiedCount] = useState<number>(0);
  const [isPolling, SetIsPolling] = useState<boolean>(true);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const pollingInterval = 180000;

  const resourcestState = useSelector((state: RootState) => state.resources);

  const fetchList = async () => {
    if (isLoading) {
      return;
    }

    try {
      setIsLoading(true);
      const response = await axiosInstance.get("/exports/list");

      if (response) {
        const {
          unnotifiedMediaCount,
        }: { unnotifiedMediaCount: number } = response.data.data;

        setUnnotifiedCount(unnotifiedMediaCount);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  const getIconColor = (theme: string) => {
    if (isHovered) {
      return theme === "light" ? "#484A48" : "#FFFFFF";
    }
    if (theme === "light") {
      return "#818381";
    } else if (theme === "dark") {
      return "#a1bee2";
    } else {
      return "#000000";
    }
  };

  useEffect(() => {
    const polling = async () => {
      while (isPolling) {
        await fetchList();
        await new Promise((resolve) => setTimeout(resolve, pollingInterval));
      }
    };

    polling();

    return () => {
      SetIsPolling(false);
    };
  }, [isPolling]);

  return (
    <Menu.Item
      key="6"
      onClick={(e) => {
        setUnnotifiedCount(0);
        props.handleClick();
      }}
      disabled={isEmptyObject(resourcestState.resources.data) ? true : false}
    >
      <Badge
        count={unnotifiedCount}
        style={{ fontSize: "80%" }}
        size="small"
        offset={[6, 6]}
      >
        <DownloadOutlined
          onMouseOver={() => setIsHovered(true)}
          onMouseOut={() => setIsHovered(false)}
          style={{
            fontSize: "140%",
            color: getIconColor(props.theme),
          }}
        />
      </Badge>
    </Menu.Item>
  );
};

export default ExportItem;
